import { addRUTHyphen, removeRUTHyphen } from './RUTFormatter'

const deepClone = object => {
    return JSON.parse(JSON.stringify(object))
}

/**
 *
 * @param {*} arrData
 * @param {*} arrFormat
 * @example
 * [
 *  {
 *      back: 'backend_prop_name'
 *      front: 'frontendPropName'
 *  },
 *  {
 *      back: 'backend_prop_name2'
 *      front: 'frontendPropName2'
 *  },
 * ]
 */
const replacePropertyNames = (object, arrFormat, reverse) => {
    arrFormat.forEach(format => {
        if(reverse){
            if(object[format.front]){
                object[format.back] = object[format.front]
                delete object[format.front]
            }
        }else{
            if (object[format.back]) {
                object[format.front] = object[format.back]
                delete object[format.back]
            }
        }
    })
    return object
}

const objectToFrontEndFormat = (object, arrFormat) => {
    object = replacePropertyNames(object, arrFormat, false)
    if(object.rut) object.rut = removeRUTHyphen(object.rut)
    return object
}

const arrayToFrontEndFormat = (arrData, arrFormat) => {
    arrData = arrData.map(item => {
        return objectToFrontEndFormat(item, arrFormat)
    })
    return arrData
}

const objectToBackendFormat = (object, arrFormat) => {
    object = replacePropertyNames(object, arrFormat, true)
    if(object.rut) object.rut = addRUTHyphen(object.rut)
    return object
}

const arrayToBackEndFormat = (arrData, arrFormat) => {
    arrData = arrData.map(item => {
        return objectToBackendFormat(item, arrFormat)
    })
    return arrData
}

export { 
    deepClone, 
    replacePropertyNames,
    objectToFrontEndFormat,
    objectToBackendFormat,
    arrayToFrontEndFormat,
    arrayToBackEndFormat
}
